import { Component, computed, ElementRef, HostListener, inject, signal, ViewChild } from '@angular/core';
import { InternalAuthService, UtilityService } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { AppDataService, StaticDataService } from 'services';
import { DashboardPageService } from '../dashboard.page.service';
import { VegaService } from '../display-types/vega/vega.service';
import { DashboardFiltersDialog } from './dashboard-filters.dialog';
import { DashboardSettingsDialog } from './dashboard-settings.dialog';


@Component({
	selector: 'dashboard-toolbar-part',
	imports: [],
	templateUrl: './dashboard-toolbar.part.html',
	styleUrl: './dashboard-toolbar.part.scss',
})
export class DashboardToolbarPart {

	@ViewChild('menuBtn') menuBtn!: ElementRef;
	@ViewChild('menu') menu!: ElementRef;

	private readonly auth = inject(InternalAuthService);
	private readonly appData = inject(AppDataService);
	private readonly staticData = inject(StaticDataService);
	private readonly util = inject(UtilityService);
	public readonly pageService = inject(DashboardPageService);
	public readonly vegaService = inject(VegaService);
	public readonly dialogService = inject(DialogService);


	/**
	 * Whether the hamburger menu is currently visible.  The html uses an @if to
	 * display it when set.
	 */
	public isMenuOpen = signal(false);

	toggleMenu() {
		this.isMenuOpen.set(!this.isMenuOpen());
	}


	/**
	 * Handles when the user clicks the Sign out menu option in the hanburger menu.
	 */
	signOut() {
		this.auth.signOut();
		this.isMenuOpen.set(false);
	}


	/**
	 * Listen for document clicks to determine if the hamburger menu is open
	 * and needs to be closed, because the user clicked outside the menu.
	 */
	@HostListener('document:click', ['$event'])
	documentClick(event: MouseEvent) {

		if (!this.isMenuOpen()) return;

		const clickedToggle = this.menuBtn.nativeElement.contains(event.target);
		const clickedInsideMenu = this.menu?.nativeElement.contains(event.target);

		if (!clickedToggle && !clickedInsideMenu) this.isMenuOpen.set(false);
	}


	public printPage() {
		window.print();
	}


	public async openDialog(dialog: 'Settings' | 'Filters' | 'Vega Charts' | 'Vega Layouts') {

		this.isMenuOpen.set(false);

		if (dialog == 'Vega Charts') this.vegaService.openDialog('View Charts');
		else if (dialog == 'Vega Layouts') this.vegaService.openDialog('Edit Layouts');
		else {
			const component = dialog == 'Settings' ? DashboardSettingsDialog : DashboardFiltersDialog;
			const action = await this.dialogService.showCustom(component, {}, 1000, 700);
		}
	}


	//
	// Render mode
	//

	public renderModeClass = computed(() => {
		const renderSvg = this.pageService.renderSvg() && !this.pageService.showQuickFiltersPanel();
		return 'fa-regular ' + (renderSvg ? 'fa-toggle-large-on' : 'fa-toggle-large-off' );
	});

	public renderModeClick() {
		this.pageService.toggleRenderMode();
	}

	public renderModeMenuClass = computed(() => {
		const disabled = this.pageService.showQuickFiltersPanel();
		return 'menu-separator' + (disabled ? ' menu-disabled' : '');
	});

	public printerMenuClass = computed(() => {
		const disabled = !this.pageService.renderSvg() || this.pageService.showQuickFiltersPanel();
		return disabled ? 'menu-disabled' : '';
	});
	
}
